import React from 'react';
import { NavigationRoute, AppNavigationType } from '../../../api/Navigation';
import RouteWrapper from './RouteWrapper';
import { Switch, Route } from 'react-router-dom';
import { getFormRoutes } from '../../../screens/forms/forms';
import CustomToDoListRoot from '../../../screens/custom-to-do-list/components/CustomToDoListRoot';
import StandaloneToDoListRoot from '../../../screens/custom-to-do-list/components/StandaloneToDoListRoot';
import { featureEnabledInEnvironment } from '../../../../config/feature-toggles';
import { FullScreenError, FullScreenErrorType } from '../screen/FullScreenError';
import Auth0Wrapper from './Auth0Wrapper';
import { PatientFormsTitleInjection } from '../../../screens/custom-to-do-list/components/PatientFormsTitleInjection';

type RoutesWithContext = {
  routes: NavigationRoute[];
};

const Auth0RoutesWithContext = (props: RoutesWithContext) => {
  return (
    <Switch>
      {props.routes.map((route, index) => {
        return <RouteWrapper key={index} {...route} />;
      })}
    </Switch>
  );
};

const FormRoutes = () => {
  return (
    <Switch>
      {getFormRoutes().map((route, index) => (
        <Route key={index} {...route.routeProps} component={route.Component} />
      ))}
      <Route
        render={() => (
          <FullScreenError
            title={'Page Not Found'}
            message={'The page was deleted, the URL is incorrect, or some other error occurred.'}
            type={FullScreenErrorType.OUTAGE}
          />
        )}
      />
    </Switch>
  );
};

const CustomToDoList = () => (
  <PatientFormsTitleInjection>
    <CustomToDoListRoot />
  </PatientFormsTitleInjection>
);

const StandaloneToDoList = () => (
  <PatientFormsTitleInjection>
    <StandaloneToDoListRoot />
  </PatientFormsTitleInjection>
);

type AppNavigatorProps = {
  routes: AppNavigationType;
};

const AppNavigator: React.FC<AppNavigatorProps> = (props) => {
  const { routes } = props;
  const auth0Routes = [...routes.AUTH0_AUTHENTICATED, ...routes.AUTH0_UNAUTHENTICATED];

  const outagePage = (
    <Route
      render={() => (
        <FullScreenError
          title={'Page Not Found'}
          message={'The page was deleted, the URL is incorrect, or some other error occurred.'}
          type={FullScreenErrorType.OUTAGE}
        />
      )}
    />
  );

  return (
    <Switch>
      <Route path="/form" component={FormRoutes} />
      {featureEnabledInEnvironment('enableStandaloneChecklist') ? (
        <Route path="/standalone-checklist" component={StandaloneToDoList} />
      ) : (
        outagePage
      )}
      {featureEnabledInEnvironment('enableFormChecklist') ? (
        <Route path="/checklist" component={CustomToDoList} />
      ) : (
        outagePage
      )}
      {featureEnabledInEnvironment('enablePatientPortal') ? (
        <Route
          path={auth0Routes.map((route) => route.path)}
          render={() => {
            return (
              <Auth0Wrapper>
                <Auth0RoutesWithContext routes={auth0Routes} />
              </Auth0Wrapper>
            );
          }}
        />
      ) : (
        outagePage
      )}
    </Switch>
  );
};

export default AppNavigator;
